const notNull = (data) => 
{
    if(data === null || data === undefined)
    {
        return("This field cannot be empty")
    }
}

export default notNull